<span>
  <i class="fas fa-id-card mr-2"></i>
  Gerente&nbsp;&nbsp;|
</span>

<span>
  &nbsp;&nbsp;<i class="fas fa-exclamation-triangle mr-2"></i>
  Alertas
</span>

<div class="float-right d-none d-sm-block"><b>Versão</b> {{ appVersion }}</div>
